module.exports = __webpack_public_path__ + "img/203.8cdfb400.jpg";